const API_USERS_BASE_URL = "/users";
const API_WHOAMI_URL = `${API_USERS_BASE_URL}/me`;
const API_AUTHENTICATE_URL = `${API_USERS_BASE_URL}/authenticate`;
const API_LOGOUT_URL = `${API_USERS_BASE_URL}/logout`;
const API_REFRESH_TOKEN_URL = `${API_USERS_BASE_URL}/refresh-token`;
const API_PASSWORD_CHANGE_URL = `${API_USERS_BASE_URL}/password-change`;
const API_EMAIL_CONFIRM_URL = `${API_USERS_BASE_URL}/confirm-email`;
const API_PASSWORD_FORGOT_URL = `${API_USERS_BASE_URL}/password-forgot`;
const API_PASSWORD_RESET_URL = `${API_USERS_BASE_URL}/password-reset`;
const API_ISSUERS_FOR_USER = `/issuers/for-user`;
const API_ISSUERS_BASE = `/issuers`;
const API_ISSUERS_CHANNELS = `/all-channels`;
const API_DOWNLOADS = `/downloads`;
const API_DOWNLOADS_FILE = `/types/downloads/file/`;

const API_GET_TERMS = "/term";
const API_GET_ATTACHMENTTYPES = "/document/attachment-types";
const API_GET_LANGUAGES = "/public/languages";

const LANDING_URL = "/issuer/dashboard";
const LOGIN_URL = "/public/user/auth";
const FORGOT_PASSWORD_URL = "/public/user/forgot-password";

const apiUsersUrls = {
  API_ISSUERS_FOR_USER,
  API_USERS_BASE_URL,
  API_WHOAMI_URL,
  API_REFRESH_TOKEN_URL,
  API_AUTHENTICATE_URL,
  API_LOGOUT_URL,
  API_PASSWORD_CHANGE_URL,
  API_EMAIL_CONFIRM_URL,
  API_PASSWORD_FORGOT_URL,
  API_PASSWORD_RESET_URL,
};

const apiStaticDataUrls = {
  API_GET_TERMS,
  API_GET_ATTACHMENTTYPES,
  API_GET_LANGUAGES,
};

const issuerUrls = {
  LANDING_URL,
  LOGIN_URL,
  FORGOT_PASSWORD_URL,
  API_ISSUERS_BASE,
  API_ISSUERS_CHANNELS,
  API_DOWNLOADS,
  API_DOWNLOADS_FILE,
};

export { apiStaticDataUrls, apiUsersUrls, issuerUrls };
